import { PatientSelectorType } from './enums';

export const selectorTypeOptions = [
  { value: PatientSelectorType.Program, label: 'By Program' },
  { value: PatientSelectorType.HealthManager, label: 'By Health Manager' },
];

export default {};
